export default __webpack_public_path__ + "static/404-c516faef0f6b4ac8fc66e8bcef3a95a8.png";